<template>

  <div>
    <!--nav start-->

    <div id="nav">
      <ul class="nav">
        <li :class="routerstr.indexOf('index') != -1 ? 'active' : ''" @click="pageClick('/index')">首页</li>
        <li :class="routerstr.indexOf('notice') != -1 ? 'active' : ''" @click="pageClick('/notice')">医院通知</li>
        <li :class="routerstr.indexOf('news') != -1 ? 'active' : ''" @click="pageClick('/news')">新闻中心</li>
        <li :class="routerstr.indexOf('message') != -1 ? 'active' : ''" @click="pageClick('/message')">信息公告</li>
        <li :class="routerstr.indexOf('department') != -1 ? 'active' : ''" @click="pageClick('/department')">科室介绍</li>
        <li :class="routerstr.indexOf('information') != -1 ? 'active' : ''" @click="pageClick('/information')">健康资讯</li>
        <li :class="routerstr.indexOf('contact') != -1 ? 'active' : ''" @click="pageClick('/contact')">联系我们</li>
      </ul>
    </div>
    <!--nav end-->
    <div id="banner">

      <el-carousel :interval="5000" arrow="always" v-model="banner" :autoplay="setting.autoplay"
        :autoplay-speed="setting.autoplaySpeed" :dots="setting.dots" :radius-dot="setting.radiusDot"
        :trigger="setting.trigger" :arrow="setting.arrow" height="630px">
        <el-carousel-item v-for="(item, index) in bannerlist" :key="index">
          <div class="demo-carousel">
            <img :src="'/dev-api' + item.filePath" width="100%" alt="item.title">
          </div>
        </el-carousel-item>
      </el-carousel>

    </div>
    <div id="news">
      <!--news start-->
      <div class="news_item notice">
        <div class="news_item_index">
          <img :src="indexdata.home_notice_pic" width="480" height="340" alt="">
          <dl class="news_item_dl">
            <dt class="news_item_dt">
              <div class="news_item_dt_title">医院通知</div>
              <div class="news_item_dt_more">
                <a href="javascript:void(0);" @click="pageClick('/notice')">查看更多</a>
              </div>
            </dt>
            <dd v-for="(item, index) in notice" :key="index">
              <a href="javascript:void(0);" @click="pageQueryClick('/noticedetail', item.noticeId)">{{ item.title }}</a>
            </dd>
          </dl>
        </div>
      </div>
      <!--start end-->
      <!--news start-->
      <div class="news_item notice">
        <div class="news_item_index">
          <img :src="indexdata.home_news_pic" width="480" height="340" alt="">
          <dl class="news_item_dl">
            <dt class="news_item_dt">
              <div class="news_item_dt_title">重大新闻</div>
              <div class="news_item_dt_more">
                <a href="javascript:void(0);" @click="pageClick('/news')">查看更多</a>
              </div>
            </dt>
            <dd v-for="(item, index) in news" :key="index">
              <a href="javascript:void(0);" @click="pageQueryClick('/newsdetail', item.newsId)">{{ item.title }}</a>
            </dd>
          </dl>
        </div>
      </div>
      <!--start end-->
      <!--news start-->
      <div class="news_item notice">
        <div class="news_item_index">
          <img :src="indexdata.home_message_pic" width="480" height="340" alt="">
          <dl class="news_item_dl">
            <dt class="news_item_dt">
              <div class="news_item_dt_title">信息公告</div>
              <div class="news_item_dt_more">
                <a href="javascript:void(0);" @click="pageClick('/message')">查看更多</a>
              </div>
            </dt>
            <dd v-for="(item, index) in message" :key="index">
              <a href="javascript:void(0);" @click="pageQueryClick('/messagedetail', item.messageId)">{{ item.title
                }}</a>
            </dd>
          </dl>
        </div>
      </div>
      <!--start end-->
    </div>
    <div id="about">
      <div class="index_about">
        <div class="index_about_title">医院简介</div>
        <div class="index_about_content">
          <div class="index_about_content_img">
            <img class="index_about_content_image" :src="indexdata.home_introduce_pic" width="630" height="500" alt="">
          </div>
          <div class="index_about_content_text" v-html="indexdata.home_introduce"></div>
        </div>
      </div>
    </div>
    <div id="culture">
      <div class="index_culture">
        <div class="index_culture_title">医院文化</div>
        <div class="index_culture_list">
          <!--culture start-->
          <div class="index_culture_list_item" v-for="(item, index) in culturelist" :key="index"
            @click="activeClick(item.id)" :class="activeStatus == item.id ? 'active' : ''">
            <div class="index_culture_list_item_ba">
              <img :src="indexdata.home_culture_pic" width="100%" height="464" alt="">
              <div class="index_culture_list_item_ba_up"></div>
            </div>
            <div class="index_culture_list_item_title">{{ item.title }}</div>
            <img class="index_culture_list_item_image_line" src="../../static/imgs/culture_line.png" width="146"
              height="12" alt="">
            <div class="index_culture_list_item_image_activeline"></div>
            <div class="index_culture_list_item_bottom">
              <img class="index_culture_list_item_image_bottom" :src="'../../static/imgs/culture' + index + '.png'"
                width="80" height="80" alt="">
              <div class="index_culture_list_item_bottom_text">{{ item.content }}</div>
            </div>
          </div>
          <!--culture end-->
        </div>
      </div>
    </div>
    <div id="department">
      <div class="department_title">科室介绍</div>
      <div class="department_info">
        <div class="department_info_left">
          <img :src="indexdata.home_room_pic" width="650" height="450" alt="">
        </div>
        <div class="department_list">
          <div class="department_list_tab">
            <div class="department_list_tab_item" v-for="(item, index) in department" :key="index"
              :class="departmentActive == index ? 'active' : ''">
              <p @click="departmentActiveClick(index)">{{ item.roomTypeName }}</p>
              <img class="department_list_tab_item_downimg" src="../../static/imgs/index_department.png" width="33"
                height="29" alt="">
            </div>
            <div class="department_list_tab_item" @click="pageClick('/department')"><span>更多科室介绍</span></div>
          </div>
          <div class="department_list_content">
            <p @click="pageQueryClick('/departmentdetail', item.roomId)" v-for="(item, index) in departmentList"
              :key="index" style="">
              <span class="department_list_content_text">{{ item.roomName }}</span>
              <span class="department_list_content_right"> › </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IndexApi from '@/api/index.js';
export default {
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      routerstr: '/index',
      /*背景图片*/
      bgimg_url: '',
      /*是否正在提交*/
      logining: false,
      /*基础配置*/
      baseData: {},
      activeStatus: 11,
      setting: {
        autoplay: true,
        autoplaySpeed: 5000,
        dots: 'inside',
        radiusDot: false,
        trigger: 'click',
        arrow: 'hover'
      },
      indexdata: {
        home_introduce: '',//首页的医院简介
        home_introduce_pic: '',//医院简介封面图
        home_notice_pic: '',//首页图-医院通知
        home_news_pic: '',//首页图-重大新闻
        home_message_pic: '',//首页图-信息公告
        home_culture_pic: '',//首页图-医院文化
        home_room_pic: '',//首页图-科室介绍"
      },
      culturelist: [],
      banner: 0,
      bannerlist: [],
      notice: [],
      news: [],
      message: [],
      department: [],
      departmentList: [],
      departmentActive: 0,
    };
  },
  created() {
    this.getData();
    this.getCulture();
    this.getBanner();
    this.getNotice();
    this.getNews();
    this.getMessage();
    this.getDepartment();
  },
  methods: {
    departmentActiveClick(index) {
      this.departmentList = this.department[index].dto;
      this.departmentActive = index;
    },
    /*页面跳转*/
    pageClick(row) {
      this.$router.push(row);
    },
    pageQueryClick(row, id) {
      this.$router.push({ path: row, query: { id: id } });
    },
    activeClick(num) {
      let self = this;
      if (num == self.activeStatus) {
        self.activeStatus = 0;
      } else {
        self.activeStatus = num;
      }

    },
    /*获取基础配置*/
    getData() {
      let self = this;
      IndexApi.baseinfo(true)
        .then(res => {
          self.loading = false;
          var list = res.data;
          for (let i = 0; i < list.length; i++) {
            if (list[i].dictParentKey == 'home_introduce') {
              self.indexdata.home_introduce = list[i].dictName;
            }
            if (list[i].dictParentKey == 'home_introduce_pic') {
              self.indexdata.home_introduce_pic = '/dev-api' + list[i].dictName;
            }
            if (list[i].dictParentKey == 'home_notice_pic') {
              self.indexdata.home_notice_pic = '/dev-api' + list[i].dictName;
            }
            if (list[i].dictParentKey == 'home_news_pic') {
              self.indexdata.home_news_pic = '/dev-api' + list[i].dictName;
            }
            if (list[i].dictParentKey == 'home_message_pic') {
              self.indexdata.home_message_pic = '/dev-api' + list[i].dictName;
            }
            if (list[i].dictParentKey == 'home_culture_pic') {
              self.indexdata.home_culture_pic = '/dev-api' + list[i].dictName;
            }
            if (list[i].dictParentKey == 'home_room_pic') {
              self.indexdata.home_room_pic = '/dev-api' + list[i].dictName;
            }
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    getCulture() {
      let self = this;
      IndexApi.culturelist(true)
        .then(res => {
          self.loading = false;
          self.culturelist = res.data;

        })
        .catch(error => {
          self.loading = false;
        });
    },
    getBanner() {
      let self = this;
      IndexApi.banner(true)
        .then(res => {
          self.loading = false;
          self.bannerlist = res.data;

        })
        .catch(error => {
          self.loading = false;
        });
    },
    getNotice() {
      let self = this;

      let Params = {};
      Params.page = 1;
      Params.limit = 3;
      IndexApi.notice(Params, true)
        .then(res => {
          self.loading = false;
          self.notice = res.data.list;

        })
        .catch(error => {
          self.loading = false;
        });
    },
    getNews() {
      let self = this;

      let Params = {};
      Params.page = 1;
      Params.limit = 3;
      IndexApi.news(Params, true)
        .then(res => {
          self.loading = false;
          self.news = res.data.list;

        })
        .catch(error => {
          self.loading = false;
        });
    },
    getMessage() {
      let self = this;

      let Params = {};
      Params.page = 1;
      Params.limit = 3;
      IndexApi.message(Params, true)
        .then(res => {
          self.loading = false;
          self.message = res.data.list;

        })
        .catch(error => {
          self.loading = false;
        });
    },
    getDepartment() {
      let self = this;

      let Params = {};
      Params.page = 1;
      Params.limit = 3;
      IndexApi.department(Params, true)
        .then(res => {
          self.loading = false;
          self.department = res.data;
          self.departmentList = res.data[0].dto;

        })
        .catch(error => {
          self.loading = false;
        });
    },
  }
};
</script>

<style lang="scss" scoped>
#banner {
  width: 1474px;
  margin: 0 auto;
}

#news {
  width: 1180px;
  margin: 42px auto 0;
  display: flex;
  justify-content: center;

  .news_item {
    width: 480px;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.15);
    margin: 0 8px;

    .news_item_dl {
      padding: 0 38px 9px;

      .news_item_dt {
        display: flex;
        justify-content: space-between;
        padding: 10px 0 13px;
        font-size: 24px;

        .news_item_dt_title {
          font-size: 20px;
          line-height: 42px;
        }

        .news_item_dt_more {
          a {
            height: 32px;
            padding: 5px 17px;
            border-radius: 30px;
            border: 1px solid #DEDEDE;
            line-height: 20px;
            font-size: 12px;
            color: #999;
          }
        }
      }

      dd {
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;

        a {
          font-size: 16px;
          color: #333;
          display: block;
          height: 52px;
          line-height: 52px;
        }
      }

      dd::before {
        position: absolute;
        content: '';
        left: 0;
        bottom: 0;
        right: 0;
        height: 2px;
        background: #DEDEDE;
      }

      dd:last-child::before {
        background: none;
      }
    }
  }
}

#about {

  .index_about {
    width: 1474px;
    margin: 0 auto;

    .index_about_title {
      margin: 50px 0;
      height: 50px;
      line-height: 50px;
      font-size: 36px;
      color: #333333;
    }

    .index_about_content {
      height: 634px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .index_about_content_img {
        flex: 1;
      }

      .index_about_content_text {
        // flex: 1;
        // height: 520px;
        padding: 0 0 0 40px;
        color: #333333;
        line-height: 36px;
        letter-spacing: 3px;
        font-size: 20px;
        text-indent: 2em;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        // -webkit-line-clamp: 13;
      }
    }
  }
}

#culture {
  margin: 40px 0 0 0;

  .index_culture {
    width: 1474px;
    margin: 0 auto;

    .index_culture_title {
      margin: 40px 0 30px;
      font-size: 36px;
      color: #333;
      height: 50px;
      line-height: 50px;
    }

    .index_culture_list {
      display: flex;
      justify-content: space-between;

      .index_culture_list_item {
        width: 294px;
        height: 464px;
        text-align: center;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
        position: relative;

        .index_culture_list_item_ba {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          display: none;
        }

        .index_culture_list_item_title {
          height: 42px;
          line-height: 42px;
          font-size: 30px;
          color: #333;
          margin: 80px 0 0 0;
        }

        .index_culture_list_item_image_line {
          margin: 70px auto 140px;
        }

        .index_culture_list_item_image_activeline {
          position: relative;
          margin: 48px 48px 70px;
          height: 2px;
          background: #fff;
          display: none;
        }

        .index_culture_list_item_image_activeline::before {
          position: absolute;
          content: '';
          left: 20px;
          bottom: 0;
          height: 2px;
          width: 50px;
          background: #007E4F;
        }

        .index_culture_list_item_bottom_text {
          display: none;
          padding: 0 60px 0 80px;
          font-size: 20px;
          line-height: 45px;
          color: #FFFFFF;
          letter-spacing: 3px;
          text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.8);
        }

        .index_culture_list_item_image_bottom {
          margin: 0 auto;
        }
      }

      .index_culture_list_item.active {
        width: 696px;

        .index_culture_list_item_ba {
          display: block;
          position: absolute;
          left: 0;
          bottom: 0;
          right: 0;
          top: 0;

          .index_culture_list_item_ba_up {
            position: absolute;
            left: 0;
            bottom: 0;
            right: 0;
            top: 0;
            background: rgba(0, 0, 0, 0.4);
          }
        }

        .index_culture_list_item_title {
          color: #fff;
          text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.8);
          position: relative;
          z-index: 100;
        }

        .index_culture_list_item_image_line {
          display: none;
        }

        .index_culture_list_item_image_bottom {
          display: none;
        }

        .index_culture_list_item_image_activeline {
          display: block;
          z-index: 100;
        }

        .index_culture_list_item_bottom_text {
          display: block;
          position: relative;
          z-index: 100;
        }
      }

      .index_culture_list_item:hover {
        background: rgba(0, 126, 79, 0.1);
        cursor: pointer;
      }

      .index_culture_list_item.active:hover {
        background: rgba(0, 0, 0, 0.4);
        cursor: pointer;

        .index_culture_list_item_ba {
          background-color: rgba(0, 0, 0, 0.4);
        }
      }
    }
  }
}

#department {
  width: 1474px;
  margin: 0 auto;

  .department_title {
    margin: 40px 0;
    height: 50px;
    line-height: 50px;
    font-size: 36px;
    color: #333;
  }

  .department_info {
    display: flex;
    justify-content: space-between;

    .department_list {
      flex: 1;
      padding: 20px 0 0 58px;

      .department_list_tab {
        display: flex;
        justify-content: space-between;

        .department_list_tab_item {
          position: relative;
          border-radius: 10px;

          p {
            padding: 10px 12px;
            border-radius: 10px;
            height: 60px;
            line-height: 40px;
            cursor: pointer;
            position: relative;
            border: 1px solid rgba(0, 0, 0, 0.15);
            // box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15);
            z-index: 10;
            font-size: 14px;
          }

          /*p::before{
              position: absolute;content: '';left:50%;bottom: -15px;margin-left:-15px;height:30px;
              width:30px;background: #fff;border: 1px solid #DEDEDE;z-index: 8;transform: rotate(90deg);-webkit-transform: rotate(90deg);
            }*/
          span {
            padding: 10px 20px;
            display: block;
            cursor: pointer;
            font-size: 16px;
          }

          .department_list_tab_item_downimg {
            display: none;
            position: absolute;
            left: 50%;
            bottom: -26px;
            margin-left: -16px;
            z-index: 100;
          }
        }

        .department_list_tab_item.active {
          box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.30);

          .department_list_tab_item_downimg {
            display: block;
          }
        }
      }

      .department_list_content {
        margin: 15px 0 0 0;
        overflow: hidden;
        height: 380px;

        p {
          margin: 10px 10px 0 0;
          cursor: pointer;
          display: inline-block;
          align-items: center;
          border: 1px solid #ccc;
          border-radius: 5px;

          span.department_list_content_text {
            font-size: 13px;
            display: block;
            padding: 9px 30px;
            height: 46px;
            float: left;
            line-height: 28px;
          }

          span.department_list_content_right {
            font-size: 20px;
            color: #999;
            display: block;
            padding: 8px;
            border-left: 1px solid #ccc;
            height: 46px;
            float: right;
            line-height: 28px;
          }
        }

        p:hover {
          color: #007E4F;
        }

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue